'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const DEFAULT_THUMBNAIL_CONFIG = {
    width: 300,
    height: 300,
};
const genCacheVersionQuery = (cacheVersion) => (cacheVersion ? `v=${cacheVersion}` : '');
const getCdnUrlFactory = (config) => (instanceId, path, params = {}) => {
    const { domain, instanceMapper, transformationQueries, cacheVersion } = config;
    const { transformation = params.asThumbnail ? DEFAULT_THUMBNAIL_CONFIG : {} } = params;
    const transformationQuery = transformationQueries(transformation);
    const cacheVersionQuery = genCacheVersionQuery(cacheVersion);
    const hasQueryParams = [transformationQuery, cacheVersionQuery].some((query) => query !== '');
    return `${domain}${instanceMapper(instanceId)}${path}${hasQueryParams ? '?' : ''}${transformationQuery}${cacheVersionQuery ? `&${cacheVersionQuery}` : ''}`;
};

exports.genCacheVersionQuery = genCacheVersionQuery;
exports.getCdnUrlFactory = getCdnUrlFactory;
//# sourceMappingURL=get-cdn-url.util.js.map
